/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "1473ff4786ca953dd1b5d2c16a664f0245fe208a";
